// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class AssetTypeResource extends Resource {
    basePath: string = 'services/asset-type/';

    objectPath: string = 'services/asset-type/{ident}/';
}
